import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import {
	FormControl, InputLabel, Input, IconButton, InputAdornment,
} from '@material-ui/core';
import { Cancel, Save } from '@material-ui/icons';
import useFirebase from '../hooks/firebase';

export default function FirebaseInput(props) {
	const {
		className,
		label,
		doc,
		docPath,
		docKey,
		disabled,
	} = props;

	const { firestore } = useFirebase();

	const [value, setValue] = useState('');
	const [touched, setTouched] = useState(false);

	useEffect(() => {
		if (touched) return;
		if (doc) {
			setValue(doc[docKey] || '');
		} else {
			setValue('');
		}
	}, [touched, doc, docKey]);

	const handleChange = ({ target }) => {
		setTouched(true);
		setValue(target.value);
	};

	const handleSave = () => {
		const ref = firestore.doc(docPath);
		ref.set({
			[docKey]: value,
		}, { merge: true }).then(() => {
			setTouched(false);
		}).catch(console.error);
	};
	const handleCancel = () => {
		setTouched(false);
	};
	const handleKeyDown = (event) => {
		if (!touched) return;
		if (event.key === 'Enter') {
			handleSave();
		} else if (event.key === 'Escape') {
			handleCancel();
		}
	};

	return (
		<FormControl className={className}>
			{label && (
				<InputLabel>{label}</InputLabel>
			)}
			<Input
				value={value || ''}
				disabled={disabled}
				onChange={handleChange}
				onKeyDown={handleKeyDown}
				endAdornment={touched && (
					<InputAdornment position="end">
						<IconButton
							onClick={handleSave}
						>
							<Save />
						</IconButton>
						<IconButton
							onClick={handleCancel}
							edge="end"
						>
							<Cancel />
						</IconButton>
					</InputAdornment>
				)}
			/>
		</FormControl>
	);
}

FirebaseInput.defaultProps = {
	className: undefined,
	label: undefined,
	disabled: false,
	doc: undefined,
};

FirebaseInput.propTypes = {
	className: propTypes.string,
	label: propTypes.string,
	// eslint-disable-next-line react/forbid-prop-types
	doc: propTypes.object,
	docPath: propTypes.string.isRequired,
	docKey: propTypes.string.isRequired,
	disabled: propTypes.bool,
};
